import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { TradingOfferStatus } from '../../../types/TradingOffer';
import tradingOfferStatus from '../constants/tradingOfferStatus';

type TradingOfferStatusBadgeProps = {
  status: TradingOfferStatus;
};

const TradingOfferStatusBadge: FC<TradingOfferStatusBadgeProps> = ({
  status,
}) => {
  const { t } = useTranslate();

  const currentStatus = tradingOfferStatus[status];

  return (
    <span className={`${currentStatus.style} fw-medium d-inline`}>
      <em className={`icon ni ${currentStatus.icon}`} />{' '}
      {t(currentStatus.label)}
    </span>
  );
};

export default TradingOfferStatusBadge;
